import { render } from "./FaqsPage.vue?vue&type=template&id=7132e0a8"
import script from "./FaqsPage.vue?vue&type=script&lang=js"
export * from "./FaqsPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__